import { Component } from '@angular/core';
import { NavigationService } from '../../core/services/navigation.service';
import { menus } from '../../core/models/constants';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'slide-main-navigation',
  templateUrl: 'slide-main-navigation.component.html',
  styleUrls: []
})

export class SlideMainNavigationComponent {
  public menuItems: Array<INavItem>;
  public language: string;

  constructor(private _navigationService: NavigationService, private _router: Router, private _translateService: TranslateService) { }

  ngOnInit() {
    this._navigationService.mainMenuNavItems.subscribe(navItems => {
      this.menuItems = navItems;
      this.language = this._translateService.getBrowserLang();
      if (this.menuItems.length && this.menuItems[0].SubItems.length) {
        this._router.navigate(['mc', menus[this.menuItems[0].SubItems[0].Name].path]);
      }
    });
  }

  public getPath(name: string): string[] {
    const path = menus[name].path;
    
    if (path.startsWith('/')) {
      return [path];
    }
    
    return ['/mc', path];
  }
}
